import TextField from "@mui/material/TextField";
import {s_char} from "../../_signals/s_char";
import {Item} from "../CharStyled";
import React from "react";
import updChar from "../../_sig_api/updChar";

export default function CharBlutschaden() {
    return <Item style={{
        borderColor: "white", borderWidth: 8, borderStyle: 'solid',
    }}>
        <TextField InputLabelProps={{shrink: true}}
                   onChange={e => updChar([{k:'blutschaden',v: parseInt(e.target.value as string)}])}
                   value={s_char.value.blutschaden}
                   variant="standard"
                   type="number"
                   label="Blut Schaden:"
                   name="blutschaden"/>
    </Item>
}